import type { SUBJECT_6W_URI } from '~/features-shared/libs/interfaces/entity'
import type { ITaggable } from '~/features-shared/tags/interfaces/tags'

export const contentTagsMap = ref(new Map<SUBJECT_6W_URI, ITaggable>())
export const settingsTagsMap = ref(new Map<SUBJECT_6W_URI, ITaggable>())
export const isTaggerReady = ref(false)
export const isUserTagsUtilsReady = ref(false)

export const getTagsForContent = (id?: SUBJECT_6W_URI) => id ? contentTagsMap.value.get(id) : undefined
export const getTagsForCommunitySettings = (uri: SUBJECT_6W_URI) => settingsTagsMap.value.get(uri)
